export default "__VITE_ASSET__BZ0A1uUs__"